export default __webpack_public_path__ + "static/media/sample_iotmakers.e089b5a0.xlsx";